/**
 * Converts a UTC date string to a Date object in the local timezone
 * @param dateString - UTC date string to convert
 * @returns Date object adjusted to local timezone
 */
export const getLocalDateFromUTC = (dateString: string): Date => {
  const date = new Date(dateString);
  const utcDate = new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
  return utcDate;
};

/**
 * Formats a date to a string in the local timezone
 * @param date - Date object to format
 * @returns Formatted date string
 */
export const formatDate = (date: Date) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
};

/**
 * Calculates the number of days between two dates
 * @param startDate - Start date
 * @param endDate - End date (defaults to current date)
 * @returns Number of days between dates
 */
export const calculateDaysBetween = (
  startDate: Date | string,
  endDate: Date = new Date()
): number => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const differenceInTime = end.getTime() - start.getTime();
  return Math.floor(differenceInTime / (1000 * 60 * 60 * 24));
};
